import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Input,
    InputGroup,
    InputRightAddon,
    Flex,
    Icon,
    Text,
    TableContainer,
    VStack,
    useBreakpointValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";
import Pagination from "../../Components/Common/Pagination";

const loginData = [
    { user: "Mayank", ip: "192.168.1.1", location: "Delhi, India", browser: "Chrome on Windows", time: "2025-04-07 07:00 PM" },
    { user: "John Doe", ip: "192.168.1.45", location: "Mumbai, India", browser: "Safari on iPhone", time: "2025-04-06 08:30 PM" },
];

const LoginHistory = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const totalEntries = loginData.length;
    const totalPages = Math.ceil(totalEntries / limit);
    const data = loginData.slice((page - 1) * limit, page * limit);

    const SIDEBAR_WIDTH = "240px";
    const isMobile = useBreakpointValue({ base: true, md: false });

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box p={{ base: 4, md: 8 }} bg="gray.50" minH="100vh" mt="64px" ml={{ base: 0, md: SIDEBAR_WIDTH }}>
                <Flex mb={8} justify="space-between" align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap={3}>
                    <Text fontSize="2xl" fontWeight="semibold" color="#1a202c">Login History</Text>
                    <InputGroup maxW="300px" size="md">
                        <Input bg="white" placeholder="Search..." borderRight="none" _focus={{ borderColor: "#4f46e5", boxShadow: "none" }} />
                        <InputRightAddon bg="#4f46e5" cursor="pointer">
                            <Icon as={SearchIcon} color="white" />
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                {isMobile ? (
                    <VStack spacing={4} align="stretch">
                        {data.map((d, i) => (
                            <Box key={i} bg="white" p={4} borderRadius="lg" boxShadow="sm" border="1px solid #e2e8f0">
                                <Flex justify="space-between" mb={2}>
                                    <Text fontWeight="600" fontSize="sm">User</Text>
                                    <Text fontSize="sm">{d.user}</Text>
                                </Flex>
                                <Flex justify="space-between" mb={2}>
                                    <Text fontWeight="600" fontSize="sm">IP Address</Text>
                                    <Text fontSize="sm">{d.ip}</Text>
                                </Flex>
                                <Flex justify="space-between" mb={2}>
                                    <Text fontWeight="600" fontSize="sm">Location</Text>
                                    <Text fontSize="sm">{d.location}</Text>
                                </Flex>
                                <Flex justify="space-between" mb={2}>
                                    <Text fontWeight="600" fontSize="sm">Browser/OS</Text>
                                    <Text fontSize="sm">{d.browser}</Text>
                                </Flex>
                                <Flex justify="space-between">
                                    <Text fontWeight="600" fontSize="sm">Time</Text>
                                    <Text fontSize="sm" color="gray.500">{d.time}</Text>
                                </Flex>
                            </Box>
                        ))}
                    </VStack>
                ) : (
                    <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0">
                        <TableContainer>
                            <Table variant="simple">
                                <Thead bg="#4f46e5">
                                    <Tr h="50px">
                                        <Th color="white" textTransform="none" borderTopLeftRadius="lg">User</Th>
                                        <Th color="white" textTransform="none">IP Address</Th>
                                        <Th color="white" textTransform="none">Location</Th>
                                        <Th color="white" textTransform="none">Browser/OS</Th>
                                        <Th color="white" textTransform="none" textAlign="right" borderTopRightRadius="lg">Time</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.map((d, i) => (
                                        <Tr key={i} _hover={{ bg: "gray.50" }}>
                                            <Td fontWeight="600" fontSize="sm">{d.user}</Td>
                                            <Td fontSize="sm">{d.ip}</Td>
                                            <Td fontSize="sm">{d.location}</Td>
                                            <Td fontSize="sm">{d.browser}</Td>
                                            <Td fontSize="sm" color="gray.500" textAlign="right">{d.time}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                <Pagination 
                    currentPage={page}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    limit={limit}
                    onPageChange={setPage}
                    onLimitChange={(newLimit) => {
                        setLimit(newLimit);
                        setPage(1);
                    }}
                />
            </Box>
        </>
    );
};

export default LoginHistory;
